function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import DropdownIcon from '@bfly/icons/Dropdown';

import classNames from 'classnames';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Button from './Button';
const messages = defineMessages({
  goBack: {
    "id": "@bfly/ui:backButton.goBack",
    "defaultMessage": "Go back"
  }
});
const styles = require('./BackButton-styles.module.scss');

function BackButton({
  className,
  children,
  ...props
}) {
  const intl = useIntl();
  return React.createElement(Button, _extends({}, props, {
    theme: "link",
    "aria-label": intl.formatMessage(messages.goBack),
    className: classNames(className, styles.button)
  }), React.createElement(DropdownIcon, {
    className: styles.arrow,
    "aria-hidden": "true"
  }), children);
}

export default BackButton;